/* eslint-disable max-len */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { string } from 'prop-types';

const Success = (props) => (
  <SvgIcon
    style={{
      width: '16px',
      height: '16px',
    }}
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{props.title}</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="messages"
        transform="translate(-110.000000, -115.000000)"
        fill={props.fill}
        fillRule="nonzero"
      >
        <g id="success" transform="translate(110.000000, 115.000000)">
          <path
            d="M8,0 C3.5816,0 0,3.5816 0,8 C0,12.4184 3.5816,16 8,16 C12.4184,16 16,12.4184 16,8 C16,3.5816 12.4184,0 8,0 Z M12.5656,6.1656 L6.9656,11.7656 C6.8096,11.9216 6.6048,12 6.4,12 C6.1952,12 5.9904,11.9216 5.8344,11.7656 L3.4344,9.3656 C3.1216,9.0528 3.1216,8.5472 3.4344,8.2344 C3.7472,7.9216 4.2528,7.9216 4.5656,8.2344 L6.4,10.0688 L11.4344,5.0344 C11.7472,4.7216 12.2528,4.7216 12.5656,5.0344 C12.8784,5.3472 12.8784,5.8528 12.5656,6.1656 Z"
            id="success-path-1"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

Success.propTypes = {
  title: string,
  fill: string,
};

Success.defaultProps = {
  title: '',
  fill: '#3FB139',
};

export default Success;
